import fvSubassembly from "../fvSubassembly"
export default class fvPolygonObj extends fvSubassembly {
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system);
        this.initPoints = JSON.parse(JSON.stringify(this.points));
        this.create();
        if (this.isDelayedWaiting) {
            this.complete = callback;
        } else {
            callback(this);
        }
        //创建图元
        //添加折线
        this.polygonDom = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        system.appendChild(this.polygonDom);
        if(this.renderType==4||this.renderType==5||this.renderType==6){
            this.polygonDefs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
            system.insertBefore(this.polygonDefs, this.polygonDom);
        }
        this.createSucss(this.polygonDom, sContent);
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.polygonPath = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                system.appendChild(this.polygonPath);
            }
        }
        //创建样式
        this.parent = parent;
        this.moveWidth = this.borderWidth/2;
        this.createStyle();
    }
    createStyle() {
        this.setPosition();
        // 添加虚线属性
        super.chooseRenderType(this.lineType, this.polygonDom)
        this.polygonDom.setAttribute('stroke-width', this.borderWidth);
        this.polygonDom.style.width=this.width+"px";
        this.polygonDom.style.height=this.height+"px";
        this.setFillColor();
        this.setBorderColor();

        this.Render();
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.polygonPath.innerHTML = "";
                this.drawStereo(this.polygonPath, this.polygonDom);
            }
        }

    }
    // 设置位置
    setPosition() {
        // 根据x y 因边框、缩放改变导致绘制多边形重新计算
        for (var i = 0; i < this.points.length; i++) {
            var points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX;
            var points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY;
            this.points[i][0] = points0 * this.magnification.x + this.cx - this.parent.parentX - this.borderWidth / 2;
            this.points[i][1] = points1 * this.magnification.y + this.cy - this.parent.parentY - this.borderWidth / 2;
        }
        this.polygonDom.setAttribute('points', this.points);
    }
    // 设置填充颜色
    setFillColor() {
        let rgbArray = this.color.colorRgb(this.opacity / 255);
        this.polygonDom.style.fill = rgbArray;
    }
    // 设置边框颜色
    setBorderColor() {
        this.polygonDom.style.stroke = this.borderColor;
    }
    // 显示隐藏
    isShow(value) {
        value ? this.polygonDom.style.display = 'block' : this.polygonDom.style.display = 'none';
    }
    //风格渲染
    Render() {
        if (this.renderConfig == undefined || JSON.stringify(this.renderConfig) == "{}") return;
        switch (this.renderType) {
            // case 1:  //模式1
            // case 2:  //模式2
            // case 3:  //模式3
            case 4:  //svg线性渐变效果
                this.linearGradient(this.uuid(), this.renderConfig, this.polygonDom, this.cx - this.parent.x, this.cy - this.parent.y,this.polygonDefs);
                break;
            case 5:  //svg路径渐变效果
                this.polygonDom.style.width = this.width;
                this.polygonDom.style.height = this.height;
                this.radialGradient(this.uuid(), this.renderConfig, this.polygonDom, this.cx - this.parent.x, this.cy - this.parent.y,this.polygonDefs);
                break;
            case 6:  //svg纹理渐变效果
                this.pattern(this.uuid(), this.polygonDom,this.polygonDefs);
                break;
            default:
                break;
        }
    }
    init() {
        super.init();
        this.temp = Math.round(this.borderWidth / 2);
        // 根据x y 因边框、缩放改变导致绘制多边形重新计算
        for (var i = 0; i < this.points.length; i++) {
            var points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX;
            var points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY;
            this.points[i][0] = points0 * this.magnification.x + this.cx - this.parent.parentX - this.borderWidth;
            this.points[i][1] = points1 * this.magnification.y + this.cy - this.parent.parentY - this.borderWidth;
        }
    }
    onDraw() {
        //调用动画 完成动画 更改实时样式
        this.executePreAnimation(this.polygonDom);
        this.polygonDom.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'}) rotate(${this.rotating + 'deg'}`;
        this.polygonDom.style.transformOrigin = `${this.originPinitX + "px"}  ${this.originPinitY + "px"}`;
    }
    //生成path路径
    getpolygonPath(points) {
        var path =
            'M' + points.slice(0,2).join(' ') +
            'L' + points.slice(2).join(' ')+ 'z';
        return path;
    }
}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvPolygonObj.js